import { h } from "preact";
import { useState, useEffect } from "preact/hooks";
import { Box, Button, DialogActions, DialogContent, Dialog, DialogTitle, Typography, Stack } from "@mui/material";

export default function ManageMeetingDialog(props) {
    const [state, setState] = useState({ mode: "init" });
    const handleClose = () => {
        props.onClose();
    };

    const handleAppointmentCanceled = (id) => {
        const requestOptions = {
            method: "GET",
            headers: { "Content-Type": "application/json" },
        };
        fetch("/api/425fd5b9a1cf4861b765b18fdb0bafa5/" + id, requestOptions)
            .then((response) => {
                return response.json();
            })
            .then((res) => {
                switch (res.res) {
                    case "ok":
                        //	app.ref.ref.current.handleChangeState({ o: true, m: "Le mail a été renvoyé", s: "success" });
                        window.location.reload();
                        break;
                    case "err":
                        break;
                    default:
                        break;
                }
            });
    };

    return (
        <Dialog onClose={handleClose} aria-labelledby="add-user-dialog" open={props.state.opened} maxWidth="md" fullWidth={false}>
            <DialogTitle id="add-user-dialog"><Typography variant="h5" gutterBottom>Gérer mon rendez-vous</Typography></DialogTitle>
            <DialogContent dividers>
                <Stack spacing={1}>
                    <Typography>{props.state.params.mtg.lbl}</Typography>
                    <Typography variant="h5">à l'adresse:</Typography>
                    <Typography>{props.state.params.mtg.adr}</Typography>
                    <Typography>{props.state.params.mtg.adr2}</Typography>
                    {state.mode === "cancel" &&
                        <Typography variant="h5">Souhaitez-vous vraiment annuler le rendez-vous ?</Typography>
                    }
                    {state.mode === "change" &&
                        <Typography variant="h5">Vous souhaitez décaler le rendez-vous, êtes-vous sûr ?</Typography>
                    }
                </Stack>
            </DialogContent>
            <DialogActions>
                {state.mode === "init" && <Box display="flex" justifyContent="space-between" alignItems="center" style="width: 100%">
                    <Box p={1}>
                        <Button variant="contained" onClick={() => setState({ ...state, mode: "cancel" })} >
                            Annuler le RDV
                        </Button>
                    </Box>
                    {/* <Box p={1}>
                        <Button variant="contained" onClick={() => setState({ ...state, mode: "change" })} >
                            Décaler le RDV
                        </Button>
                    </Box> */}
                    <Box p={1}>
                        <Button variant="contained" onClick={handleClose}>
                            Fermer
                        </Button>
                    </Box>
                </Box>}
                {state.mode === "cancel" && <Box display="flex" justifyContent="space-between" alignItems="center" style="width: 100%">
                    <Box p={1}>
                        <Button variant="contained" onClick={() => setState({ ...state, mode: "init" })} >
                            NON
                        </Button>
                    </Box>
                    <Box p={1}>
                        <Button
                            variant="contained"
                            onClick={() => {
                                handleAppointmentCanceled(props.state.params.mtg.uid);

                            }} >
                            OUI
                        </Button>
                    </Box>
                </Box>}
                {state.mode === "change" && <Box display="flex" justifyContent="space-between" alignItems="center" style="width: 100%">
                    <Box p={1}>
                        <Button variant="contained" onClick={() => setState({ ...state, mode: "init" })} >
                            NON
                        </Button>
                    </Box>
                    <Box p={1}>
                        <Button variant="contained" onClick={handleClose} >
                            OUI
                        </Button>
                    </Box>
                </Box>}
            </DialogActions>
        </Dialog >
    );
}
